import script from "./BaseHeaderMegaMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseHeaderMegaMenu.vue?vue&type=script&lang=ts&setup=true"

import "./BaseHeaderMegaMenu.vue?vue&type=style&index=0&id=d6a0b758&lang=scss"

const __exports__ = script;

export default __exports__